import {AxiosError} from 'axios';
import {useQuery, UseQueryOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

type CurrentCompetitorsReturn = {
  current_competitors: number;
};

const queryKey = (challengeID: string) => ['trivia-current-competitors', challengeID];

const queryFn = (challengeID: string) =>
  api
    .get<{data: CurrentCompetitorsReturn}>(`v1/challenges/${challengeID}/current`)
    .then((res) => res.data.data.current_competitors);

export const useCurrentCompetitorsQuery = (challengeID: string, options?: UseQueryOptions<number, AxiosError>) =>
  useQuery<number, AxiosError>(queryKey(challengeID), () => queryFn(challengeID), {
    ...options,
    staleTime: 30 * 1000,
  });

useCurrentCompetitorsQuery.queryKey = queryKey;
useCurrentCompetitorsQuery.queryFn = queryFn;
